import { Environment } from './environment.interface';
import { production } from './environment.production';

export const environment: Environment = {
    ...production,
    GLOBAL_NAV_TAXONOMY: 'https://n4v.web.vanguard.com/secure-site-components.js',
    GLOBAL_NAV_STYLES: 'https://n4v.web.vanguard.com/nav-preload.css',
    UHNW_DPOC_URL: 'https://dpoc.web.vanguard.com/build/web-components.esm.js',
};
